import React from "react";
import { FormattedMessage } from "react-intl";

import { Switch } from "src/common/components/Switch";
import { IsLockedContext } from "src/features/forms/context/IsLockedContext";
import { useValue } from "src/features/forms/hooks/useField";
import { SwitchProps } from "src/features/forms/types";

export const SwitchRenderer: React.FunctionComponent<SwitchProps> = ({
	label,
	...directProps
}) => {
	const isLocked = React.useContext(IsLockedContext);
	const [checked, onChangeChecked] = useValue(false);
	return (
		<Switch
			{...directProps}
			disabled={isLocked}
			checked={checked}
			onChangeChecked={onChangeChecked}
		>
			{label && <FormattedMessage {...label} />}
		</Switch>
	);
};
